import { CreateSigningAppointmentFormData } from '../../04_confirmationStep/convertToCreateSigningAppointmentRequest';
import { useMemo } from 'react';

// This hook returns true if a Signing Appointment is a DSS appointment and is NOT a draft
export const useEmailRequired = ({
  isDigitalScheduling,
  isDigitalSchedulingDraft,
  signers,
}: CreateSigningAppointmentFormData): boolean => {
  return useMemo(() => {
    if (!isDigitalScheduling || !!signers?.some((signer) => !!signer.email)) {
      return false;
    }
    // a digital scheduling draft is a notaryOnly DSS appointment that is NOT a sigSync.
    // all other DSS appointments require an email.
    return !isDigitalSchedulingDraft;
  }, [isDigitalScheduling, isDigitalSchedulingDraft, signers]);
};
